import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import {getAvailableColumns} from "pages/PageDefectActReasons/api";

export const path = '/defectActReasons';

const PageDefectActReasons: React.FC = (props) => {
    const loader = {
        page: () => import('pages/PageDefectActReasons/page'),
        columns: getAvailableColumns
    };

    const DefectActReasons = Loadable.Map({
        loader,
        loading: LoadableLoading,
        render(loaded, loadedProps) {
            const Page = loaded.page.default

            return (
                <Page
                    {...loadedProps}
                    {...props}
                    columns={loaded.columns}
                />
            )
        }
    });

    return <DefectActReasons/>;
};

export default PageDefectActReasons;
